<div class="overlay" style="background-color: #f0f8ff52; z-index: 9999;" [hidden]="!visible">
  <kendo-loader class="spinner" [type]="'infinite-spinner'" [themeColor]="'Dark'" [size]="'large'"></kendo-loader>
</div>
